import { useState, useRef } from 'react';
import { fetch } from '../../../utils/api-wrapper';

export function useAutoRefresh() {
  const [refreshing, setRefreshing] = useState(false);
  const mountedRef = useRef(true);

  const refreshData = () => {
    setRefreshing(true);
    return new Promise((resolve, reject) => {
      fetch('/plaid/trigger_manual_transaction_fetch', 'POST', {}, (response) => {
        if (!mountedRef.current) return;
        setRefreshing(false);
        resolve(response);
      }, (error) => {
        if (!mountedRef.current) return;
        setRefreshing(false);
        reject(error);
      });
    });
  };

  return {
    refreshing,
    refreshData,
  };
}
